<template>
  <v-card>
    <div style="min-height: 4px">
      <v-progress-linear
        v-if="loading"
        indeterminate
      ></v-progress-linear>
    </div>
    <v-data-table
      :headers="tableColumnHeaders"
      :items="totalTicketsPorFila"
      item-key="filaNome"
      no-data-text="Nenhum agente disponível"
      class="table-rounded"
      :footer-props="{
        'items-per-page-text': 'Filas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      @click:row="onFilaClick"
      style="cursor: pointer"
    >
      <!-- client -->
      <template #[`item.client`]="{ item }">
        <div class="d-flex align-center">
          <v-avatar
            :color="item.avatar ? '' : item.avatarColor"
            :class="`v-avatar-light-bg ${item.avatarColor}--text`"
            size="30"
          >
            <v-img
              v-if="item.avatar"
              :src="require(`@/assets/images/avatars/${item.avatar}`)"
            ></v-img>
            <span
              v-else
              class="font-weight-medium"
            >{{ item.fullName.slice(0, 2).toUpperCase() }}</span>
          </v-avatar>

          <div class="d-flex flex-column ms-3">
            <span class="d-block text--primary  font-weight-semibold text-truncate">{{ item.fullName }}</span>
          </div>
        </div>
      </template>

      <!-- total -->
      <template #[`item.total`]="{ item }">
        {{ item.total }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

export default {
  props: {
    dadosTickets: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    totalTicketsPorFila: [],
  }),

  watch: {
    dadosTickets() {
      if (this.dadosTickets) {
        this.getTotalTicketsFilasPorCategoriaStatus()
      }
    },
  },

  methods: {
    getTotalTicketsFilasPorCategoriaStatus() {
      this.totalTicketsPorFila = []
      this.dadosTickets.forEach(fila => {
        this.totalTicketsPorFila.push({
          id: fila.filaId,
          avatarColor: 'primary',
          fullName: fila.filaNome,
          totalNovo: fila.tickets.some(it => it.categoriaStatusNome === 'Novo') ? fila.tickets.find(it => it.categoriaStatusNome === 'Novo').totalTickets : 0,
          totalAndamento: fila.tickets.some(it => it.categoriaStatusNome === 'Andamento') ? fila.tickets.find(it => it.categoriaStatusNome === 'Andamento').totalTickets : 0,
          totalResolvido: fila.tickets.some(it => it.categoriaStatusNome === 'Resolvido') ? fila.tickets.find(it => it.categoriaStatusNome === 'Resolvido').totalTickets : 0,
          totalFinalizado: fila.tickets.some(it => it.categoriaStatusNome === 'Finalizado') ? fila.tickets.find(it => it.categoriaStatusNome === 'Finalizado').totalTickets : 0,
          total: fila.tickets.reduce((acc, { totalTickets }) => acc + totalTickets, 0),
        })
      })
    },
    onFilaClick(item) {
    const url = this.$router.resolve({ name: 'fila', params: { id: item.id } }).href;

    window.open(url, '_blank');
    },
  },

  setup() {
    const tableColumnHeaders = [
      { text: 'Fila', value: 'client' },
      { text: 'Novo', value: 'totalNovo' },
      { text: 'Andamento', value: 'totalAndamento' },
      { text: 'Resolvido', value: 'totalResolvido' },
      { text: 'Finalizado', value: 'totalFinalizado' },
      { text: 'Total', value: 'total' },
    ]

    return {
      tableColumnHeaders,
    }
  },
}
</script>
